import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

document.querySelectorAll('.element-steps').forEach((el) => {
  if (el.dataset.disableAnimations !== undefined) {
    return
  }

  const timeline = gsap.timeline({
    paused: true,
    scrollTrigger: {
      trigger: el,
    },
  })

  if (window.matchMedia('(min-width: 768px)').matches) {
    timeline.fromTo('.steps-divider', { width: 0 }, { width: '100%', duration: 1.25 })
  }

  timeline.fromTo('.step-item svg', { scale: 0 }, { scale: 1, stagger: 0.25, duration: 0.5, delay: 0.25 }, '<')
  timeline.fromTo('.step-item-pos ', { opacity: 0 }, { opacity: 1, stagger: 0.25, duration: 1 }, '<')
  timeline.fromTo(
    '.step-item-content ',
    { opacity: 0, y: '150%' },
    { opacity: 1, y: 0, stagger: 0.25, duration: 0.5 },
    '<'
  )
})
